export const getFaqData = _availableDocumentTypes => {
  return [
    {
      answer:
        'If you don\'t participate in any of these programs, click "Skip this step" and you\'ll be given the opportunity to self-attest to your income level.',
      name: 'what-if',
      question: "What if I don't participate in any of these programs?",
    },
    {
      answer:
        'The community solar program is independent of any other assistance/support programs. As long as you qualify as a low- or moderate-income household, you will be eligible to join this program.',
      name: 'affect-on-other-programs',
      question: 'Will this affect other support programs I am enrolled in?',
    },
    {
      answer:
        'We’ll review the information you’ve provided. If you’re eligible, we’ll notify you that you have been placed on a solar farm and you’ll start receiving savings once the farm goes live. ',
      name: 'what-happens-next',
      question: 'What happens next?',
    },
  ];
};
